import React from 'react';

const LessonTitle = ({myLessons}) => {
    return (
        <div className="my-course">
            <div className="child-course-name">{myLessons.name}</div>
            {
                myLessons.numberOfLessons && myLessons.numberOfLessons > 0 ?
                    <div className="child-percent-course">{myLessons.completedLessons}/{myLessons.numberOfLessons}</div>
                    :
                    ""
            }

        </div>
    )
};

export default LessonTitle;